import { CardSuit } from "../card/Card";
import { PopupBiddingChoiceType } from "../popup/PopupBiddingTakeSuit";

export function CardSuitToPopupBiddingChoiceType(cardSuit: CardSuit): PopupBiddingChoiceType
{
    switch (cardSuit) {
        case CardSuit.CLUBS:
            return PopupBiddingChoiceType.CLUBS;
        case CardSuit.DIAMONDS:
            return PopupBiddingChoiceType.DIAMONDS;
        case CardSuit.HEARTS:
            return PopupBiddingChoiceType.HEARTS;
        case CardSuit.SPADES:
            return PopupBiddingChoiceType.SPADES;
    }
}